import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { DirectionProvider } from 'context/direction-provider'
import { FontProvider } from 'context/font-provider'
//import './styles/style.css'
import { ThemeProvider } from 'context/theme-provider'
import { isLoggedIn } from 'helpers/authentication'
import { Provider } from 'react-redux'
import { Toaster } from 'sonner'
import { getHomeData } from 'store/home/homeSlice'
import { router } from './router'
import store, { AppDispatch } from './store/store'
import './styles/index.css'

// SearchProvider is provided inside the authenticated layout
// (components/layout/authenticated-layout.tsx) so we avoid
// mounting it here to prevent hooks (useNavigate) being called
// outside the router context.

const root = createRoot(document.getElementById('root') as HTMLDivElement)

const fetchHomeData = () => {
  if (isLoggedIn()) {
    const dispatch: AppDispatch = store.dispatch
    dispatch(getHomeData())
  }
}
fetchHomeData()
setInterval(fetchHomeData, 60 * 1000) // 1 minute

root.render(
  <StrictMode>
    <Provider store={store}>
      <Toaster duration={2000} />
      <ThemeProvider>
        <FontProvider>
          <DirectionProvider>
            <RouterProvider router={router} />
          </DirectionProvider>
        </FontProvider>
      </ThemeProvider>
    </Provider>
  </StrictMode>
)
